var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-1"},[(
      (_vm.institution && !_vm.institution.kl_assessment) ||
      (_vm.user && _vm.user.groups.includes(7))
    )?[_c('Page404')]:[_c('NewEvaluation',{attrs:{"allows_crud":_vm.allows_crud,"evaluation_id":_vm.evaluation_id,"instrument_id":_vm.instrument_id}}),(_vm.section)?_c('NewDashboardCustomFab',{attrs:{"section_id":_vm.section.id,"show_teacher_views":true}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }